import { useState } from 'react'
import { T } from '../lib/tokens'
import { loadSettings, saveSettings, applyAccentHue, type UserSettings } from '../lib/settings'

export function SettingsDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [settings, setSettings] = useState<UserSettings>(loadSettings)

  function update<K extends keyof UserSettings>(key: K, value: UserSettings[K]) {
    const next = { ...settings, [key]: value }
    setSettings(next)
    saveSettings({ [key]: value })
    if (key === 'accentHue') applyAccentHue(value as number)
  }

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',opacity:open?1:0,pointerEvents:open?'auto':'none',transition:'opacity 0.2s',zIndex:40 }} />
      <aside style={{ position:'fixed',top:0,right:0,bottom:0,width:320,background:T.bgPanel,borderLeft:`1px solid ${T.borderHi}`,transform:open?'translateX(0)':'translateX(100%)',transition:'transform 0.25s cubic-bezier(.2,.7,.3,1)',display:'flex',flexDirection:'column',zIndex:41,fontFamily:T.font }}>
        <div style={{ padding:'14px 16px',borderBottom:`1px solid ${T.border}`,display:'flex',alignItems:'center',gap:8 }}>
          <span style={{ fontSize:14 }}>⚙</span>
          <span style={{ fontSize:13,fontWeight:600,color:T.text }}>設定</span>
          <button onClick={onClose} style={{ marginLeft:'auto',background:'transparent',border:'none',color:T.textDim,cursor:'pointer',fontSize:18,padding:'2px 6px' }}>×</button>
        </div>

        <div style={{ flex:1,overflowY:'auto',padding:16,display:'flex',flexDirection:'column',gap:20 }}>

          {/* アクセントカラー */}
          <Section label="アクセントカラー">
            <input
              type="range" min={0} max={360} step={5}
              value={settings.accentHue}
              onChange={e => update('accentHue', Number(e.target.value))}
              style={{ width:'100%',accentColor:T.accent }}
            />
            <div style={{ display:'flex',justifyContent:'space-between',fontSize:10,fontFamily:T.fontMono,color:T.textMute,marginTop:4 }}>
              <span>0°</span>
              <span style={{ color:T.accent }}>{settings.accentHue}°</span>
              <span>360°</span>
            </div>
            {/* プレビュー */}
            <div style={{ marginTop:8,height:20,borderRadius:4,background:`linear-gradient(90deg,oklch(0.72 0.16 ${settings.accentHue}) 0%,oklch(0.60 0.20 ${(settings.accentHue+20)%360}) 100%)` }} />
            <div style={{ display:'flex',gap:6,marginTop:8,flexWrap:'wrap' }}>
              {[{label:'青紫',hue:258},{label:'緑',hue:155},{label:'橙',hue:30},{label:'ピンク',hue:350},{label:'水',hue:200}].map(p=>(
                <button key={p.hue} onClick={()=>update('accentHue',p.hue)} style={{ padding:'3px 10px',borderRadius:4,border:`1px solid ${settings.accentHue===p.hue?`oklch(0.72 0.16 ${p.hue})`:T.border}`,background:settings.accentHue===p.hue?`oklch(0.72 0.16 ${p.hue}/0.15)`:'transparent',color:T.textDim,fontSize:11,cursor:'pointer',fontFamily:T.font }}>
                  {p.label}
                </button>
              ))}
            </div>
          </Section>

          {/* カード密度 */}
          <Section label="カード密度">
            <div style={{ display:'flex',gap:8 }}>
              {([['normal','標準'],['dense','高密度']] as const).map(([val,label])=>(
                <button key={val} onClick={()=>update('density',val)} style={{ flex:1,padding:'8px',borderRadius:6,border:`1px solid ${settings.density===val?T.borderHi:T.border}`,background:settings.density===val?T.bgActive:'transparent',color:settings.density===val?T.text:T.textDim,fontSize:12,cursor:'pointer',fontFamily:T.font }}>
                  {label}
                </button>
              ))}
            </div>
          </Section>

          {/* ニュース配信の設定・ソース管理は「📰 ニュース配信」ページへ移動 */}

          {/* 情報 */}
          <Section label="情報">
            <div style={{ fontSize:11,color:T.textMute,lineHeight:1.7 }}>
              <div>MemoLake — パーソナルデータレイク</div>
              <div style={{ fontFamily:T.fontMono }}>Discord × Gemini × Cloudflare</div>
            </div>
          </Section>
        </div>
      </aside>
    </>
  )
}

function Section({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <div style={{ fontSize:10,fontFamily:T.fontMono,color:T.textMute,letterSpacing:'0.12em',marginBottom:10,textTransform:'uppercase' }}>{label}</div>
      {children}
    </div>
  )
}
